var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", [
      _c("div", { staticClass: "footer-content content inner-content" }, [
        _c("div", [
          _c("span", [_vm._v("Made with Vue ❤")]),
          _vm._v(" "),
          _c("span", [
            _vm._v("See the project on "),
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  href: "https://github.com/KyleEvan/Vue-Website"
                }
              },
              [_vm._v("GitHub")]
            )
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("Kyle Peterson")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }